export const SUPPORTED_LANGUAGES = [
  'English',
  'Spanish',
  'French',
  'German',
  'Chinese',
  'Japanese',
  'Korean',
  'Portuguese',
  'Italian',
  'Russian',
  'Arabic',
  'Hebrew',
  'Hindi',
  'Bengali',
  'Hungarian',
  'Romanian'
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
